import { useStore } from "../../stores/StoreContext";
import { AppRolesService } from "../LogicServices/AppRolesService";

export function useAppRolesService(): AppRolesService {
  const storeContext = useStore();
  return new AppRolesService(storeContext);
}
